import { render } from "./SectionSpacerClouds.vue?vue&type=template&id=3096dcb6&ts=true"
import script from "./SectionSpacerClouds.vue?vue&type=script&lang=ts"
export * from "./SectionSpacerClouds.vue?vue&type=script&lang=ts"

import "./SectionSpacerClouds.vue?vue&type=style&index=0&id=3096dcb6&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__